(function(window, undefined) {

    'use strict';


    /**
     * sapo videos suggestions parsing code. relies on cors and xml resources
     */


    var sapoNS      = 'http://videos.sapo.pt/mrss/';
    var mediaNS     = 'http://search.yahoo.com/mrss/';

    var limit = 4;
    var thumbSize = '320x240'; // 320x240
    //var thumbSize = '560x420'; // TODO NOT WORKING?!
    var modes = {
        all:  true,
        user: true
    };

    var cors = SAPO.Utility.cors,
        XML2 = SAPO.Utility.XML2;


    var getUrl = function(hash, user) {
        return ['query_rss2.html?limit=', limit, '&thumbsize=', thumbSize, '&related=', hash, ( user ? ('&user=' + user) : '' )].join('');
    };

    var parseSuggestionsXML = function(cb, tmp, queryEl) {
        var res = [];
        var itemEls = XML2.getChildren(queryEl, 'item');
        var item, it, i, f;
        for (i = 0, f = itemEls.length; i < f; ++i) {
            item = itemEls[i];
            it = {};
            it.title        = XML2.getText(item, 'title');
            it.description  = XML2.getText(item, 'description');
            it.author       = XML2.getText(item, 'author',           sapoNS);
            it.url          = XML2.getText(item, 'videoURL',         sapoNS);
            it.thumb        = XML2.getAttr(item, 'content',  'url',  mediaNS);
            it.time         = XML2.getText(item, 'time',             sapoNS);

            it.m18          = XML2.getBoolean(item, 'm18',           sapoNS);
            it.views        = XML2.getNumber( item, 'views',         sapoNS);
            it.rate         = XML2.getNumber( item, 'rate',          sapoNS);
            it.commentCount = XML2.getNumber( item, 'comment_count', sapoNS);

            it.duration = XML2.parseTime( XML2.getText(item, 'time', sapoNS) );

            res.push(it);
        }

        if (res.length === 0) {
            return cb('no results', {});
        }

        cb(null, res);
    };



    SAPO.Project.Video.sapoVideosSuggestions = function(o, cb) {

        var m = modes[o.mode];

        //console.log('suggestions mode: ', o.mode);

        if (!m) { return cb('unsupported mode', {}); }

        var suggUri = [
            o.queryDomain,
            getUrl(o.hash, o[o.mode])
        ].join('/');

        //console.log('CALLING SUGGESTIONS VIA %s', suggUri);

        var onErr = function() {
            cb('Error fecthing video suggestions!', {});
        };

        cors(
            suggUri,
            parseSuggestionsXML.bindObj(null, cb),
            onErr,
            5
        );
    };

})(window);
